import { render, staticRenderFns } from "./AddProduction.vue?vue&type=template&id=26dd51c4"
import script from "./AddProduction.vue?vue&type=script&lang=js"
export * from "./AddProduction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports